import { useCallback, useEffect, useState } from 'react';
import type OrderItemStepTodo from '@this/src/domain/arrangement/order_item_step_todo';
import { computeOrderItemStepElapsedSecondsFromTodo } from '@this/src/domain/arrangement/compute_order_item_step_elapsed_seconds';

export const useOrderItemStepPause = (
  stateTodo: OrderItemStepTodo | undefined,
  todo: OrderItemStepTodo | null
) => {
  const [isPausing, setIsPausing] = useState(false);
  const [frozenElapsedSeconds, setFrozenElapsedSeconds] = useState<number | undefined>();

  const freezeElapsedSeconds = useCallback(() => {
    if (!stateTodo) return;
    setFrozenElapsedSeconds(computeOrderItemStepElapsedSecondsFromTodo(stateTodo));
  }, [stateTodo]);

  useEffect(() => {
    setIsPausing(false);
    setFrozenElapsedSeconds(undefined);
  }, [todo?.id, todo?.traceId]);

  return {
    isPausing,
    setIsPausing,
    frozenElapsedSeconds,
    freezeElapsedSeconds
  };
};
